"use strict";

(function ($) {
    $(document).ready(function () {
        // $('.cs-why-wait .bright .scrollbar > *').css('display', 'none');
        $('.cs-why-wait').on('dragged.owl.carousel click.owl.carousel', function (e) {
            change_content('.cs-why-wait');
        });
        change_content('.cs-why-wait');
    });


    $(window).on('resize load', function () {
        if (window.matchMedia('(min-width: 768px)').matches) {
            $('.image-aero-box-').unbind('mouseenter mouseleave');
            $('.image-aero-box-0').unbind('mouseenter mouseleave');
            $('.image-aero-box-1').unbind('mouseenter mouseleave');

            if ($(document).width() > 991) {
                slider(".image-aero-box-", ".child-aero-box-");
                slider(".image-aero-box-0", ".child-aero-box-0");
                slider(".image-aero-box-1", ".child-aero-box-1");

                if (!$('.aero-box').hasClass('collapse')) {
                    $('.aero-box').addClass('collapse');
                }
            }
        } else {
            $('.image-aero-box-').unbind('mouseenter mouseleave');
            $('.image-aero-box-0').unbind('mouseenter mouseleave');
            $('.image-aero-box-1').unbind('mouseenter mouseleave');

            if ($('.aero-box').hasClass('collapse')) {
                $('.aero-box').removeClass('collapse');
            }
        }
    });

    function change_content(target)
    {
        var content_id = $(target).find('.owl-carousel .owl-item.active .bg_img').attr('data-content');
        // console.log(content_id);
        $(target + ' .bright .content').each(function () {
            if ($(this).attr('data-content') == content_id) {
                $(this).parents('.scrollbar-info').fadeIn();
            } else {
                $(this).parents('.scrollbar-info').css({'display': 'none'});
            }
        });
        $(target + ' .ltop .h_content').each(function () {
            if ($(this).attr('data-content') == content_id) {
                $(this).parents('.scrollbar-info').fadeIn();
            } else {
                $(this).parents('.scrollbar-info').css({'display': 'none'});
            }
        });
    }

    function slider(target, el)
    {
        $(target).hover(function () {
            $(el).stop().slideDown("slow");
        }, function () {
            $(el).stop().slideUp("slow");
        });
    };

})(jQuery);